
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { editGcashAccount, setConnectivityTest } from '@/api/gcash/account'
import { getAllGcash } from '@/api/gcash/groups'

@Component({
  name: 'addAccount',
  components: {},
})
export default class extends Vue {
  @Prop({ required: true }) info!: any

  private infoForm: any = {
    account_no: this.info.account_no,
    sms_id: this.info.sms_id,
    status: this.info.status,
    mpin: '',
  }

  private testSms: any = ''
  private testLoading: boolean = false
  private loading: boolean = false

  private back() {
    this.$emit('close')
  }

  private async create() {
    try {
      this.loading = true
      const data: any = {
        id: this.info.id,
        sms_id: this.infoForm.sms_id,
        status: this.infoForm.status,
        mpin: this.infoForm.mpin,
      }
      await editGcashAccount(data).then((res: any) => {
        this.$message({
          message: 'Edit successful!',
          type: 'success',
        })
        this.loading = false
        this.back()
      })
    } catch (error) {
      this.loading = false
    }
  }

  mounted() {}
}
